<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange" style="width: 100%;">
        <el-table-column label="身份名称" prop="name" align="center" />
        <el-table-column label="分组名称" prop="profitRatioTitle" align="center" />
        <el-table-column label="描述" prop="description" align="center" />
        <!-- <el-table-column label="状态" prop="isEnable" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.isEnable" :active-value="true" :inactive-value="false" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column> -->
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" />
        <el-table-column label="操作人" prop="operatedName" align="center" />
        <el-table-column label="操作" align="center" width="230">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)" v-hasPermi="['system:userIdentity:edit']">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" /> -->
    </el-card>
    <!-- 新建表单 -->
    <user-add ref="userAdd" @created="doQueryList({})" />
  </div>
</template>

<script>
import userAdd from './add'
import customerLevelApi from '@/api/sys/customerLevel'
// import sysDeptApi from '@/api/sys/sysDept'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
    userAdd
  },
  data() {
    return {
      options: {
        sysDept: []
      },
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    // sysDeptApi.findOptions().then(data => { this.options.sysDept = data })
  },
  methods: {
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        // 'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return customerLevelApi.fetchList()
        .then(data => {
          this.list = data.data
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => customerLevelApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择用户')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => customerLevelApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      customerLevelApi.update(row).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.userAdd.handleCreate()
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.userAdd.handleUpdate(row)
    }
  }
}
</script>
